import { render, staticRenderFns } from "./ListViewPublishers.vue?vue&type=template&id=2ec709b4&"
import script from "./ListViewPublishers.vue?vue&type=script&lang=js&"
export * from "./ListViewPublishers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports